import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const style = StyleSheet.create({
  container: theme => ({
    paddingHorizontal: 16,
    paddingTop: 33,
    backgroundColor: theme.colors.cardBackgroundColor,
  }),
  sectionContainer: theme => ({
    borderTopWidth: 1,
    borderColor: theme.colors.borderColorThree,
    paddingVertical: 10,
  }),
  sectionRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 10,
  },
  sectionKey: {
    fontSize: 17,
  },
  sectionValue: {
    ...Fonts.type.bold,
    fontSize: 17,
  },
  totalCostText: {
    fontSize: 25,
    ...Fonts.type.bold,
  },
  noteText: {
    marginTop: 25,
    fontSize: 16.6,
  },
  termsText: {
    fontSize: 14.6,
    lineHeight: 17,
    textAlign: 'center',
  },
  tsSection: theme => ({
    paddingTop: 23,
    marginBottom: 10,
    alignItems: 'center',
    borderTopWidth: 1,
    borderColor: theme.colors.borderColorThree,
  }),
  button: {
    marginTop: 30,
  },
});
export default style;
